<script lang="ts">
/**
 * `StudyVolumeCompareBarCard`: `.cc` card with ranked volume bars (`.dbr` / `.dbl` / `.dbt` / `.dbf` / `.dbv` — styles in `StudyPresentationShell`).
 * Title and subtitle use `{@html}` for entities; `formatValue` renders the right-hand numeric column.
 */
interface Props {
  title: string
  subtitle: string
  rows: readonly (readonly [string, number])[]
  /** Bar widths are `count / maxCount` (e.g. max claim count in the series). */
  maxCount: number
  barColors: readonly string[]
  formatValue: (count: number) => string
  cardClass?: string
  cardStyle?: string
  /** Inline `margin-top` on the row list wrapper; default matches study slides. */
  listMarginTop?: string
}

let {
  title,
  subtitle,
  rows,
  maxCount,
  barColors,
  formatValue,
  cardClass = '',
  cardStyle,
  listMarginTop = '.82rem',
}: Props = $props()
</script>

<div class="cc {cardClass}" style={cardStyle}>
  <div class="ct">{@html title}</div>
  <div class="cs">{@html subtitle}</div>
  <div class="dbrs" style="margin-top:{listMarginTop};">
    {#each rows as [name, count], i}
      {@const denom = maxCount > 0 ? maxCount : 1}
      {@const barPct = ((count / denom) * 100).toFixed(1)}
      <div class="dbr">
        <div class="dbl">{name}</div>
        <div class="dbt">
          <div
            class="dbf"
            style="width:{barPct}%;background:{barColors[i % barColors.length]};"
          ></div>
        </div>
        <div class="dbv">{formatValue(count)}</div>
      </div>
    {/each}
  </div>
</div>
